module.exports = __webpack_public_path__ + "static/media/PlayerPattern.dd9468eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/PlayerPattern.png
// module id = 535
// module chunks = 0